export default __webpack_public_path__ + "static/media/gilroy-medium.aeb54624.woff";